const catalogText = document.querySelector(".catalog-text");

if (catalogText) {
  const openButtons = document.querySelectorAll("[data-catalog-text-open]");
  const closeButtons = catalogText.querySelectorAll("[data-catalog-text-close]");
  const panel = catalogText.querySelector(".catalog-text__panel");
  const focusableSelector = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    "[tabindex]",
  ].join(",");
  let lastFocusedElement = null;

  const updateCatalogTextFocus = (enabled) => {
    catalogText.querySelectorAll(focusableSelector).forEach((element) => {
      if (!(element instanceof HTMLElement)) return;

      if (enabled) {
        const hadTabindex = element.dataset.catalogTextHadTabindex;
        if (!hadTabindex) return;

        if (hadTabindex === "true") {
          element.setAttribute("tabindex", element.dataset.catalogTextTabindex ?? "");
        } else {
          element.removeAttribute("tabindex");
        }

        delete element.dataset.catalogTextHadTabindex;
        delete element.dataset.catalogTextTabindex;
        return;
      }

      if (!element.dataset.catalogTextHadTabindex) {
        const tabindex = element.getAttribute("tabindex");
        element.dataset.catalogTextHadTabindex = tabindex === null ? "false" : "true";

        if (tabindex !== null) {
          element.dataset.catalogTextTabindex = tabindex;
        }
      }

      element.setAttribute("tabindex", "-1");
    });
  };

  const openCatalogText = () => {
    lastFocusedElement = document.activeElement;
    catalogText.classList.add("_open");
    document.body.classList.add("_catalog-text-open");
    openButtons.forEach((button) => button.setAttribute("aria-expanded", "true"));
    updateCatalogTextFocus(true);

    if (panel instanceof HTMLElement) {
      panel.setAttribute("role", "dialog");
      panel.setAttribute("aria-modal", "true");
      panel.focus({ preventScroll: true });
    }
  };

  const closeCatalogText = () => {
    catalogText.classList.remove("_open");
    document.body.classList.remove("_catalog-text-open");
    openButtons.forEach((button) => button.setAttribute("aria-expanded", "false"));

    if (panel instanceof HTMLElement) {
      panel.removeAttribute("role");
      panel.removeAttribute("aria-modal");
    }

    updateCatalogTextFocus(false);

    if (lastFocusedElement instanceof HTMLElement) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  openButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      openCatalogText();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      closeCatalogText();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && catalogText.classList.contains("_open")) {
      closeCatalogText();
    }
  });

  updateCatalogTextFocus(false);
}
